var switcher = {
    selectors: {
        buttons: '[switcher-buttons]',
        containers: '[switcher-containers]',
    },

    init: function() {
        var self  = this,
        $buttons = $( self.selectors.buttons ),
        $containers = $( self.selectors.containers );
        
        self.selectric();

        $buttons.on('click', '.features__button', function (e) {
            e.preventDefault();
            var index = $(this).index();
            if ( !$(this).hasClass('active') ) {
                $buttons.find('.active').removeClass('active');
                $(this).addClass('active');
                $containers.find('.active').css('opacity', 0);
                setTimeout(function() {
                    $containers.find('.active').removeClass('active');
                    $containers.find('.features__content').eq(index).addClass('active').css('opacity', 0);
                    setTimeout(() => {
                        $containers.find('.active').css('opacity', 1);
                    }, 1);
                }, 500);
            }
        } );
    },
    selectric: function () {
        var self = this,
        $buttons = $( self.selectors.buttons ),
        $containers = $( self.selectors.containers ),
        $selected = 0;

        $('select').selectric({
            arrowButtonMarkup: '<b class="arrow"></b>',
            nativeOnMobile: false,
        })
        .on('change', function() {
            var $newSelected = $(this).parent().parent().find('.selectric-items .selected').data('index');
            if( $selected != $newSelected ) {
                $selected = $newSelected;

                $buttons.find('.active').removeClass('active');
                $buttons.find('.features__button').eq($selected).addClass('active')
                $containers.find('.active').css('opacity', 0);
                setTimeout(function() {
                    $containers.find('.active').removeClass('active');
                    $containers.find('.features__content').eq($selected).addClass('active').css('opacity', 0);
                    setTimeout(() => {
                        $containers.find('.active').css('opacity', 1);
                    }, 1);
                }, 500);
            }
        });


    },
    
}

export { switcher };
